import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgQq = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 26"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M21.268 14.441a29.535 29.535 0 0 0-.663-1.784l-.656-1.559.001-.186c.001-5.337-3.193-8.921-7.949-8.921-4.755 0-7.95 3.584-7.95 8.92l.001.185-.643 1.528a29.15 29.15 0 0 0-.677 1.82c-.786 2.406-.845 4.157-.174 5.203.364.566.933.942 1.575 1.048-.18.67-.078 1.385.281 1.98.762 1.225 2.205 1.316 4.32 1.316A42.2 42.2 0 0 0 12 23.863c.747.066 2.044.128 3.266.128 2.115 0 3.558-.091 4.319-1.314.342-.55.469-1.28.283-1.982.65-.11 1.222-.49 1.574-1.048.67-1.046.612-2.797-.174-5.206Zm-1.757 4.081-.016.001c-.427 0-1.59-1.799-1.59-1.799 0 1.068-.578 2.61-1.827 3.616.468.137 1.041.347 1.409.607.331.232.29.47.23.566-.129.207-1.225.275-2.45.275-1.256 0-2.647-.071-3.266-.137-.618.067-2.01.137-3.266.137-1.224 0-2.32-.068-2.45-.275-.059-.096-.1-.334.23-.566.369-.258.942-.47 1.41-.607-1.25-1.008-1.827-2.548-1.827-3.617 0 0-1.164 1.8-1.59 1.8l-.017-.002c-.192-.022-.444-1.01.335-3.398.163-.501.387-1.085.612-1.646l.825-1.96c0-.023-.011-.409-.011-.607 0-3.35 1.663-6.717 5.75-6.717 4.086 0 5.748 3.367 5.748 6.718 0 .2-.01.585-.011.608l.825 1.96c.226.56.45 1.144.613 1.645.779 2.388.527 3.376.334 3.398Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

const ForwardRef = forwardRef(SvgQq)
const Memo = memo(ForwardRef)
export default Memo
